<template>
  <div v-if="loading" />
  <div v-else class="row">
    <div class="col-lg-4">
      <div class="flex-row-auto ">
        <!--begin::Card-->
        <div class="card card-custom gutter-b">
          <!--begin::Body-->
          <div class="card-body pt-4">
            <div class="d-flex justify-content-end">
              <a
                v-on:click="showAlert(last_name, first_name)"
                class="btn btn-light-danger btn-sm btn-icon mr-3"
              >
                <i
                  class="flaticon-delete-1"
                  data-toggle="popover"
                  data-placement="top"
                  data-trigger="hover"
                  data-html="true"
                  :data-content="$t('patient.delete_patient')"
                ></i>
              </a>

              <a
                v-b-modal.modal-edit-patient
                class="btn btn-light btn-sm btn-icon"
              >
                <i
                  class="flaticon-edit"
                  data-toggle="popover"
                  data-placement="top"
                  data-trigger="hover"
                  data-html="true"
                  :data-content="$t('patient.edit_patient')"
                ></i>
              </a>
            </div>

            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-12">
                <div class="d-flex align-items-center">
                  <div>
                    <a
                      href="#"
                      class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
                    >
                      {{ gamer.last_name }} {{ gamer.first_name }}
                    </a>
                    <div class="text-muted">
                      {{ $t("patient.patient") }}
                    </div>
                    <section v-if="!gamer.disabled">
                      <span
                        class="label label-light-success label-inline font-weight-bold label-lg mt-2 mb-2"
                        >{{ $t("patient.active_user") }}</span
                      >
                    </section>
                    <section v-else>
                      <span
                        class="label label-light-danger label-inline font-weight-bold label-lg mt-2 mb-2"
                        >{{ $t("patient.inactive_user") }}</span
                      >
                    </section>
                  </div>
                </div>
                <div class="pt-3 pb-3">
                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <span class="font-weight-bold mr-2">Email:</span>
                    <a
                      v-bind:href="'mailto:' + gamer.email"
                      class="text-muted text-hover-primary"
                      >{{ gamer.email }}</a
                    >
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <span class="font-weight-bold mr-2"
                      >{{ $t("patient.phone_number") }}:</span
                    >
                    <a
                      v-bind:href="'tel:' + gamer.phone_number"
                      class="text-muted text-hover-primary"
                      >{{ gamer.phone_number }}</a
                    >
                  </div>
                  <div
                    class="d-flex align-items-center justify-content-between mb-2"
                  >
                    <span class="font-weight-bold mr-2">{{
                      $t("patient.create_date")
                    }}</span>
                    <a class="text-muted text-hover-primary">{{
                      getDateString(gamer.create_date)
                    }}</a>
                  </div>
                  <div class="d-flex flex-column mb-2">
                    <span class="font-weight-bold mr-2">{{
                      $t("patient.comment")
                    }}</span>
                    <span class="text-muted"> {{ gamer.comment }}</span>
                  </div>
                </div>
              </div>

              <div class="col-12 col-sm-6 col-md-6 col-lg-12">
                <div class="row m-0">
                  <div class="col px-0 py-6 mr-8">
                    <div class="font-size-sm text-muted font-weight-bold">
                      {{ $t("patient.total_time") }}<br />
                      {{ $t("patient.in_games_h") }}
                    </div>
                    <div
                      class="font-size-h4 btn btn-sm btn-text btn-light font-weight-bold w-80px mt-1"
                    >
                      {{ total_time }}
                    </div>
                  </div>
                  <div class="col px-0 py-6">
                    <div class="font-size-sm text-muted font-weight-bold">
                      {{ $t("patient.average_time") }}<br />
                      {{ $t("patient.in_games_h") }}
                    </div>
                    <div
                      class="font-size-h4 btn btn-sm btn-text btn-light font-weight-bold w-80px mt-1"
                    >
                      {{ average_time }}
                    </div>
                  </div>
                </div>

                <!--begin::Contact-->
                <div class="pb-6"></div>
                <!--end::Contact-->

                <section v-if="!gamer.disabled">
                  <a
                    class="btn btn-light-danger font-weight-bold py-3 px-6 mb-2 text-center btn-block"
                    v-on:click="disabledGamer(true)"
                  >
                    {{ $t("patient.deactivate_patient") }}
                  </a>
                </section>
                <section v-else>
                  <a
                    class="btn btn-light-primary font-weight-bold py-3 px-6 mb-2 text-center btn-block"
                    v-on:click="disabledGamer(false)"
                  >
                    {{ $t("patient.activate_patient") }}
                  </a>
                </section>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--end::Card-->
      </div>
    </div>
    <div class="col-lg-8">
      <!--begin::Mixed Widget 5-->
      <div class="card card-custom gutter-b">
        <div class="card-header py-5">
          <ul
            class="row w-100 nav nav-light-success nav-pills"
            id="gameTab"
            role="tablist"
          >
            <li
              class="nav-item col-6 col-md-3  mr-0"
              v-if="doctor.games_info[1].active"
            >
              <a
                href="#"
                @click="onChangeGame(1, c_type)"
                :class="'py-2 nav-link flex-column ' + getGameActiveClass(1)"
                data-toggle="tab"
              >
                <div class="symbol-group symbol-hover mb-3">
                  <div class="symbol symbol-45">
                    <img src="/media/game-icons/okolo_ball_logo_square.png" />
                    <i
                      v-if="gamer.game_info[1].active"
                      class="symbol-badge bg-success"
                    ></i>
                    <i v-else class="symbol-badge bg-danger"></i>
                  </div>
                </div>
                <span class="nav-text text-center">Okolo Ball</span>
              </a>
            </li>
            <li
              class="nav-item col-6 col-md-3  mr-0"
              v-if="doctor.games_info[2].active"
            >
              <a
                href="#"
                @click="onChangeGame(2, c_type)"
                :class="'py-2 nav-link flex-column ' + getGameActiveClass(2)"
                data-toggle="tab"
              >
                <div class="symbol-group symbol-hover mb-3">
                  <div class="symbol symbol-45">
                    <img
                      src="/media/game-icons/okolo_crosses_logo_square.png"
                    />
                    <i
                      v-if="gamer.game_info[2].active"
                      class="symbol-badge bg-success"
                    ></i>
                    <i v-else class="symbol-badge bg-danger"></i>
                  </div>
                </div>
                <span class="nav-text text-center">Okolo Spider</span>
              </a>
            </li>
            <li
              class="nav-item col-6 col-md-3  mr-0"
              v-if="doctor.games_info[3].active"
            >
              <a
                href="#"
                @click="onChangeGame(3, c_type)"
                :class="'py-2 nav-link flex-column ' + getGameActiveClass(3)"
                data-toggle="tab"
              >
                <div class="symbol-group symbol-hover mb-3">
                  <div class="symbol symbol-45">
                    <img src="/media/game-icons/okolo_puzzle_logo_square.png" />
                    <i
                      v-if="gamer.game_info[3].active"
                      class="symbol-badge bg-success"
                    ></i>
                    <i v-else class="symbol-badge bg-danger"></i>
                  </div>
                </div>
                <span class="nav-text text-center">Okolo Crosses</span>
              </a>
            </li>
            <li
              class="nav-item col-6 col-md-3  mr-0"
              v-if="doctor.games_info[4].active"
            >
              <a
                href="#"
                @click="onChangeGame(4, c_type)"
                :class="'py-2 nav-link flex-column ' + getGameActiveClass(4)"
                data-toggle="tab"
              >
                <div class="symbol-group symbol-hover mb-3">
                  <div class="symbol symbol-45">
                    <img src="/media/game-icons/okolo_spider_logo_square.png" />
                    <i
                      v-if="gamer.game_info[4].active"
                      class="symbol-badge bg-success"
                    ></i>
                    <i v-else class="symbol-badge bg-danger"></i>
                  </div>
                </div>
                <span class="nav-text">Okolo Puzzle</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="card-body pt-4">
          <div class="tab-content mt-5" id="gameTabContent">
            <div
              class="tab-pane fade active show"
              id="game-1"
              role="tabpanel"
              aria-labelledby="game-tab-1"
            >
              <div class="row">
                <div class="col-12 col-sm-4">
                  <div class="row m-0">
                    <div class="col p-0">
                      <div class="font-size-sm  font-weight-bold">
                        {{ $t("patient.time") }}
                      </div>
                      <span
                        class="btn btn-sm btn-text btn-light font-weight-bold w-60px mt-1"
                        data-toggle="popover"
                        data-placement="top"
                        data-trigger="hover"
                        data-html="true"
                        :data-content="$t('patient.playing_time')"
                        >{{ game_time }}</span
                      >
                    </div>
                    <div class="col p-0 ">
                      <div class="font-size-sm  font-weight-bold">
                        {{ $t("patient.level") }}
                      </div>
                      <span
                        class="btn btn-sm btn-text btn-light font-weight-bold w-60px mt-1"
                        data-toggle="popover"
                        data-placement="top"
                        data-trigger="hover"
                        data-html="true"
                        :data-content="$t('patient.level_in_game')"
                        >{{ game_level }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-3">
                  <div class="form-group flex-column mt-3 mt-sm-0">
                    <label class="form-label">{{ $t("patient.access") }}</label>
                    <div class="w-100">
                      <b-button
                        variant="outline-primary"
                        v-if="game_active"
                        @click="onChangeGameActive(false)"
                        >{{ $t("patient.yes") }}</b-button
                      >
                      <b-button
                        variant="outline-danger"
                        v-if="!game_active"
                        @click="onChangeGameActive(true)"
                        >{{ $t("patient.no") }}</b-button
                      >
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-4">
                  <div class="form-group flex-column">
                    <label for="date-input" class="form-label"
                      >{{ $t("patient.game_available_until") }}
                    </label>
                    <date-picker
                      v-model="date_off"
                      :shortcuts="shortcuts"
                      id="date-input"
                      valueType="format"
                      @change="onChangeDateOff()"
                      class="center"
                    ></date-picker>
                  </div>
                </div>
              </div>
              <div class="">
                <ul class="nav nav-tabs" id="myTab1" role="tablist">
                  <li class="nav-item">
                    <a
                      v-if="c_type === 1"
                      @click="onChangeGame(game_id, 1)"
                      class="nav-link active"
                      data-toggle="tab"
                    >
                      <span class="nav-icon"
                        ><i class="flaticon-trophy"></i
                      ></span>
                      <span class="nav-text">{{
                        $t("patient.by_levels")
                      }}</span>
                    </a>
                    <a
                      v-else
                      @click="onChangeGame(game_id, 1)"
                      class="nav-link"
                      data-toggle="tab"
                    >
                      <span class="nav-icon"
                        ><i class="flaticon-trophy"></i
                      ></span>
                      <span class="nav-text">{{
                        $t("patient.by_levels")
                      }}</span>
                    </a>
                  </li>

                  <li class="nav-item">
                    <a
                      v-if="c_type === 2"
                      @click="onChangeGame(game_id, 2)"
                      class="nav-link active"
                      data-toggle="tab"
                    >
                      <span class="nav-icon"
                        ><i class="flaticon-time-1"></i
                      ></span>
                      <span class="nav-text">{{ $t("patient.by_time") }}</span>
                    </a>
                    <a
                      v-else
                      @click="onChangeGame(game_id, 2)"
                      class="nav-link"
                      data-toggle="tab"
                    >
                      <span class="nav-icon"
                        ><i class="flaticon-time-1"></i
                      ></span>
                      <span class="nav-text">{{ $t("patient.by_time") }}</span>
                    </a>
                  </li>
                </ul>
                <div class="tab-content mt-5" id="myTabContent1">
                  <div
                    class="tab-pane fade show active"
                    id="home-1"
                    role="tabpanel"
                    aria-labelledby="home-tab-1"
                  >
                    <apexchart
                      :options="chartOptions"
                      :series="chartDatas"
                      type="bar"
                    ></apexchart>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="profile-1"
                    role="tabpanel"
                    aria-labelledby="profile-tab-1"
                  >
                    <div id="gameChartsTime"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="game-2"
              role="tabpanel"
              aria-labelledby="game-tab-2"
            >
              Tab content 2
            </div>
            <div
              class="tab-pane fade"
              id="game-3"
              role="tabpanel"
              aria-labelledby="game-tab-3"
            >
              Tab content 3
            </div>
            <div
              class="tab-pane fade"
              id="game-4"
              role="tabpanel"
              aria-labelledby="game-tab-4"
            >
              Tab content 3
            </div>
          </div>
        </div>
      </div>
      <!--end::Mixed Widget 5-->
    </div>
    <b-modal id="modal-edit-patient" :title="$t('patient.edit_patient')">
      <form>
        <div class="form-group ">
          <label>{{ $t("patient.last_name") }}</label>
          <input
            id="last_name"
            type="text"
            class="form-control"
            v-model.trim="last_name"
            :class="{
              invalid:
                ($v.last_name.$dirty && !$v.last_name.required) ||
                ($v.last_name.$dirty && !$v.last_name.maxLength)
            }"
          />
          <!--<span class="form-text text-muted"></span>-->
          <span
            v-if="$v.last_name.$dirty && !$v.last_name.required"
            class="helper-text invalid"
            >{{ $t("patient.enter_last_name") }}</span
          >
          <small
            class="helper-text invalid"
            v-else-if="$v.last_name.$dirty && !$v.last_name.maxLength"
            >{{ $t("patient.max_length") }}
            {{ $v.last_name.$params.maxLength.max }}
          </small>
        </div>
        <div class="form-group">
          <label>{{ $t("patient.first_name") }}</label>
          <input
            id="first_name"
            type="text"
            class="form-control"
            v-model.trim="first_name"
            :class="{
              invalid:
                ($v.first_name.$dirty && !$v.first_name.required) ||
                ($v.first_name.$dirty && !$v.first_name.maxLength)
            }"
          />
          <span
            v-if="$v.first_name.$dirty && !$v.first_name.required"
            class="helper-text invalid"
            >{{ $t("patient.enter_first_name") }}</span
          >
          <small
            class="helper-text invalid"
            v-else-if="$v.first_name.$dirty && !$v.first_name.maxLength"
            >{{ $t("patient.max_length") }}
            {{ $v.first_name.$params.maxLength.max }}
          </small>
        </div>
        <div class="form-group">
          <label>{{ $t("patient.phone_number") }}</label>
          <input
            id="phone_number"
            type="text"
            class="form-control"
            v-model.trim="phone_number"
            :class="{
              invalid:
                ($v.phone_number.$dirty && !$v.phone_number.required) ||
                ($v.phone_number.$dirty && !$v.phone.maxLength)
            }"
          />
          <span
            v-if="$v.phone_number.$dirty && !$v.phone_number.required"
            class="helper-text invalid"
            >{{ $t("patient.enter_phone_number") }}</span
          >
          <small
            class="helper-text invalid"
            v-else-if="$v.phone_number.$dirty && !$v.phone_number.maxLength"
            >{{ $t("patient.enter_phone_number") }}
            {{ $v.phone_number.$params.maxLength.max }}
          </small>

          <span class="form-text text-muted"
            >{{ $t("patient.for_instance") }} +38 050 846 5692</span
          >
        </div>
        <div class="form-group">
          <label>{{ $t("patient.comment") }}</label>
          <textarea
            id="fcm_text"
            type="text"
            class="form-control"
            rows="4"
            maxlength="1024"
            v-model.trim="comment"
            :class="{
              invalid:
                ($v.comment.$dirty && !$v.comment.required) ||
                ($v.comment.$dirty && !$v.comment.maxLength)
            }"
          ></textarea>
          <span
            v-if="$v.comment.$dirty && !$v.comment.required"
            class="helper-text invalid"
            >{{ $t("patient.enter_comment") }}</span
          >
          <small
            class="helper-text invalid"
            v-else-if="$v.comment.$dirty && !$v.comment.maxLength"
            >{{ $t("patient.max_length") }}
            {{ $v.comment.$params.maxLength.max }}
          </small>
        </div>
      </form>

      <template #modal-footer="{cancel, ok}">
        <b-button variant="secondary" @click="cancel()">
          {{ $t("patient.cancel") }}
        </b-button>

        <b-button variant="primary" type="submit" @click="handleSubmit()">
          {{ $t("patient.save") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<style lang="css">
nav li span:hover,
nav li span:active {
  background-color: indianred;
  cursor: pointer;
}
</style>
<script>
/* eslint-disable no-unused-vars */

import {
  REMOVE_BODY_CLASSNAME,
  ADD_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";

import {
  mapGetters,
  mapActions
  //mapState
} from "vuex";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/uk";
import { required, maxLength } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: "patient",

  data: () => ({
    loading: true,
    date_off: null,
    gamer: null,
    doctor: null,
    game_info: [],
    c_type: 1,
    game_id: 1,
    game_active: null,
    game_level: null,
    game_time: null,
    total_level: 0,
    total_time: 0,
    average_time: 0,
    game_name: null,
    games: [],
    game_count: 0,
    sessions: [],
    gamer_id: null,
    availabilityGames: true,
    first_name: "",
    last_name: "",
    phone_number: "",
    comment: "",
    showChart: true,
    chartOptions: {
      chart: {
        height: 350,
        zoom: {
          enabled: true
        }
      }
    },
    chartDatas: {},
    chartCategories: [],
    shortcuts: [
      {
        text: "30 ",
        onClick() {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
          return date;
        }
      },
      {
        text: "60 ",
        onClick() {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 60);
          return date;
        }
      },
      {
        text: "90 ",
        onClick() {
          const date = new Date();
          date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
          return date;
        }
      }
    ]
  }),
  computed: {
    ...mapGetters(["getPatient", "getDoctor", "getUserId", "getGames"])
  },
  validations: {
    first_name: { required, maxLength: maxLength(32) },
    last_name: { required, maxLength: maxLength(32) },
    phone_number: { required, maxLength: maxLength(14) },
    comment: { maxLength: maxLength(1024) }
  },
  beforeMount() {
    this.setupChart(this.sessions, this.c_type);
  },
  async mounted() {
    this.shortcuts[0].text = "30 " + this.$t("patient.days");
    this.shortcuts[1].text = "60 " + this.$t("patient.days");
    this.shortcuts[2].text = "90 " + this.$t("patient.days");
    this.setupChart(this.sessions, this.c_type);
    this.gamer_id = this.$route.params.id;
    await this.fetchDoctorById(this.getUserId);
    await this.fetchPatientById(this.gamer_id);
    await this.fetchGames();
    this.gamer = this.getPatient;
    this.doctor = this.getDoctor;
    this.games = this.getGames;
    this.first_name = this.gamer.first_name;
    this.last_name = this.gamer.last_name;
    this.comment = this.gamer.comment;
    this.phone_number = this.gamer.phone_number;
    this.game_info = this.gamer.game_info;

    if (this.game_info[1]) {
      this.game_id = 1;
    } else if (this.game_info[2]) {
      this.game_id = 2;
    } else if (this.game_info[3]) {
      this.game_id = 3;
    } else {
      this.availabilityGames = false;
    }

    if (this.availabilityGames) {
      if (this.game_info[1]) {
        this.game_count++;
        this.total_time += this.game_info[1].total_time;
      }
      if (this.game_info[2]) {
        this.game_count++;
        this.total_time += this.game_info[2].total_time;
      }
      if (this.game_info[3]) {
        this.game_count++;
        this.total_time += this.game_info[3].total_time;
      }
      this.average_time = this.total_time / this.game_count;
      this.total_time = this.secondsToHours(this.total_time);
      this.average_time = this.secondsToHours(this.average_time);

      const sessions = this.game_info[this.game_id].sessions;

      if (sessions == null) {
        this.sessions = [];
      } else {
        this.sessions = Object.keys(sessions).map(key => ({
          ...sessions[key],
          id: key
        }));
      }
      this.showLoader(false);
      this.setupChart(this.sessions, this.c_type);

      this.date_off = this.game_info[this.game_id].date_off;
      this.game_time = this.game_info[this.game_id].total_time;
      this.game_time = this.secondsToHours(this.game_time);
      this.game_level = this.game_info[this.game_id].current_level;
      this.game_active = this.game_info[this.game_id].active;
    } else {
      this.showLoader(false);
    }
  },
  methods: {
    ...mapActions([
      "fetchDoctorById",
      "fetchPatientById",
      "fetchGames",
      "updateGameInfoById",
      "deletePatient",
      "updatePatient"
    ]),
    showLoader(stateLoading) {
      this.loading = stateLoading;
      if (stateLoading) {
        this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      } else {
        this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
      }
    },
    getDateString(dateTime) {
      var d = new Date(dateTime);
      var n = d.toLocaleDateString ();
      return n;
    },
    setupChart(sessions, cType) {
      var data = null;
      var label = null;
      var title = null;

      if (cType === 1) {
        data = sessions.map(c => c.level);
        label = this.$t("patient.level");
        title = this.$t("patient.levels_graph_by_date");
      } else if (cType === 2) {
        data = sessions.map(c => Math.floor(c.time / 60));
        label = this.$t("patient.time_m");
        title = this.$t("patient.timeline_by_date");
      }
      this.chartCategories = sessions.map(c =>
        moment(String(c.date)).format("MM.DD")
      );
      this.chartDatas = [{ name: label, data: data }];
      this.chartOptions = {
        chart: {
          height: 350,
          zoom: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top" // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"]
          }
        },
        xaxis: {
          categories: this.chartCategories,
          // position: 'top',
          axisBorder: {
            show: false
          },
          title: {
            text: this.$t("patient.date_and_format")
          },
          crosshairs: {
            fill: {
              type: "gradient",
              gradient: {
                colorFrom: "#D8E3F0",
                colorTo: "#BED1E6",
                stops: [0, 100],
                opacityFrom: 0.4,
                opacityTo: 0.5
              }
            }
          },
          tooltip: {
            enabled: true
          }
        },

        yaxis: {
          title: {
            text: label
          }
        },
        title: {
          text: title,
          floating: true,
          offsetY: 0,
          align: "center",
          style: {
            color: "#444"
          }
        },
        colors: ["#fac82a"]
      };
    },
    async updateGamer() {
      await this.fetchPatientById(this.gamer_id);
      this.gamer = this.getPatient;
      this.first_name = this.gamer.first_name;
      this.last_name = this.gamer.last_name;
      this.phone_number = this.gamer.phone_number;
      this.comment = this.gamer.comment;
    },
    getGameActiveClass(id) {
      if (id === this.game_id) {
        return "active";
      } else {
        return "";
      }
    },
    onChangeGame(id, cType) {
      try {
        this.game_id = id;
        this.c_type = cType;
        this.date_off = this.game_info[this.game_id].date_off;
        this.game_level = this.game_info[this.game_id].current_level;
        this.game_time = this.game_info[this.game_id].total_time;
        this.game_time = this.secondsToHours(this.game_time);
        this.game_active = this.game_info[this.game_id].active;

        const sessions = this.game_info[this.game_id].sessions;

        if (sessions == null) {
          this.sessions = [];
        } else {
          this.sessions = Object.keys(sessions).map(key => ({
            ...sessions[key],
            id: key
          }));
        }

        this.setupChart(this.sessions, this.c_type);
      } catch (e) {
        return;
      }
    },
    secondsToHours(duration) {
      var seconds = parseInt(duration),
        minutes = parseInt((duration / 60) % 60),
        hours = parseInt((duration / 3600) % 60);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      return hours + ":" + minutes;
    },
    async onChangeDateOff() {
      this.game_info[this.game_id].date_off = this.date_off;

      var date_off_time = new Date(this.date_off).getTime();
      var new_date_time = new Date().getTime();
      if (date_off_time < new_date_time) {
        this.gamer.game_info[this.game_id].active = false;
        this.game_active = false;
      }

      if (date_off_time > new_date_time) {
        this.gamer.game_info[this.game_id].active = true;
        this.game_active = true;
      }

      await this.updateGameInfoById({
        gamer_id: this.gamer.id,
        game_id: this.game_id,
        date_off: this.date_off,
        active: this.game_active
      });
    },
    async disabledGamer(bool) {
      if (bool == null) {
        return;
      }
      this.showLoader(true);
      try {
        let currentObj = this;
        await this.axios
          .post(
            "https://us-central1-blink-fb.cloudfunctions.net/manageUser/disabled-gamer",
            {
              uid: this.gamer_id,
              disabled: bool
            },
            {
              headers: {
                apikey: "63b5689d-a975-46ae-a1df-f9eed01f18ad"
              }
            }
          )
          .then(() => {
            currentObj.showLoader(false);
            currentObj.updateGamerInfo();
          })
          .catch(e => {
            currentObj.showLoader(false);
          });
      } catch (e) {
        this.showLoader(false);
      }
    },
    async updateGamerInfo() {
      try {
        await this.fetchPatientById(this.gamer_id);
        this.gamer = this.getPatient;
      } catch (e) {
        return;
      }
    },
    showAlert(lastName, firstName) {
      this.$swal({
        title: this.$t("patient.want_remove_patient"),
        text: lastName + " " + firstName,
        showCancelButton: true,
        confirmButtonColor: "#2f61f8",
        cancelButtonColor: "#ff5252",
        confirmButtonText: this.$t("patient.yes"),
        cancelButtonText: this.$t("patient.cancel")
      }).then(result => {
        if (result.value) {
          this.deleteGamer();
          this.$swal({
            title: this.$t("patient.deleted"),
            text: this.$t("patient.patient_deleted"),
            showCancelButton: false,
            confirmButtonColor: "#2f61f8",
            confirmButtonText: this.$t("patient.ok")
          });
        }
      });
    },
    async deleteGamer() {
      try {
        let currentObj = this;
        this.showLoader(true);
        await this.deletePatient(this.gamer)
          .then(() => {
            currentObj.$router.go(-1);
          })
          .catch(e => {
            currentObj.showLoader(false);
          });
      } catch (e) {
        this.showLoader(false);
      }
    },
    async handleSubmit() {
      let currentObj = this;
      try {
        if (this.$v.$invalid) {
          this.$v.$touch();
          return;
        }
      } catch (e) {
        return;
      }
      try {
        const gamerData = {
          id: this.gamer_id,
          first_name: this.first_name,
          last_name: this.last_name,
          phone_number: this.phone_number,
          comment: this.comment
        };
        this.showLoader(true);
        await this.updatePatient(gamerData)
          .then(() => {
            currentObj.updateGamerInfo();
            currentObj.showLoader(false);
            currentObj.$v.$reset();
          })
          .catch(e => {
            currentObj.updateGamerInfo();
            currentObj.showLoader(false);
          });
      } catch (e) {
        this.showLoader(false);
      }
    },
    async onChangeGameActive(event) {
      try {
        if (event === true) {
          let today = new Date();

          if (
            today.getTime() >
            new Date(this.gamer.game_info[this.game_id].date_off).getTime()
          ) {
            today.setMonth(today.getMonth() + 2);

            let dd = String(today.getDate()).padStart(2, "0");
            let mm = String(today.getMonth()).padStart(2, "0");
            let yyyy = today.getFullYear();

            today = yyyy + "-" + mm + "-" + dd;
            this.date_off = today;
          }
          this.game_active = true;
        }
        if (event === false) {
          let today = new Date();
          let dd = String(today.getDate()).padStart(2, "0");
          let mm = String(today.getMonth() + 1).padStart(2, "0");
          let yyyy = today.getFullYear();

          today = yyyy + "-" + mm + "-" + dd;
          this.date_off = today;
          this.game_active = false;
        }
        await this.updateGameInfoById({
          gamer_id: this.gamer.id,
          game_id: this.game_id,
          date_off: this.date_off,
          active: this.game_active
        });

        await this.updateGamer(this.gamer);
        await this.fetchDoctorById(this.getUserId);
        await this.fetchPatientById(this.gamer_id);
        await this.fetchGames();
        this.gamer = this.getPatient;
        this.doctor = this.getDoctor;
        this.games = this.getGames;
        this.game_info = this.gamer.game_info;
        this.date_off = this.game_info[this.game_id].date_off;
        this.game_active = this.game_info[this.game_id].active;
        const sessions = this.game_info[this.game_id].sessions;

        if (sessions == null) {
          this.sessions = [];
        } else {
          this.sessions = Object.keys(sessions).map(key => ({
            ...sessions[key],
            id: key
          }));
        }
        this.showLoader(false);
      } catch (e) {
        this.showLoader(false);
      }
    }
  },
  components: { DatePicker }
};
</script>
